import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onBeforeMount } from 'vue'
import monthlySalary from '@/views/ViewsComponents/salary/MonthlySalary.vue'
import annualSalary from '@/views/ViewsComponents/salary/salaryTemplate.vue'
import sendEmail from '@/views/ViewsComponents/salary/sendEmail.vue'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
  // 获取所有团队
  'GET/organizations': organizationsApi,
  // 获取所有公司
  'GET/company': companyApi,
  // 获取年度薪酬
  'POST/salaries/distributes/annual_salary': annual_salaryApi,
  // 用户下拉列表
  'GET/users/list': usersListApi,
} = Api

let fullUserList: any = ref([])
onBeforeMount(() => {
  usersListApi().then((_userList: object[]) => {
    fullUserList.value = _userList.map((_user: any) => {
      _user.fullname = _user.realName + '(' + _user.username + ')'
      return _user
    })
  })
})

const annualSalaryConfig = ref([
  {
    type: "TIME",
    label: "月份",
    value: [],
    upKey: 'months',
    upProps: { startKey: 'from', endKey: 'to'},
    props: {
      type: 'monthrange',
      clearable: true,
      'default-value': null,
    }
  },
  {
    type: 'SELECT',
    label: '姓名',
    value: [],
    upKey: 'userIds',
    options: fullUserList,
    placeholder: '请选择姓名',
    props: { clearable: true, multiple: true, 'collapse-tags': true, style: 'width: 300px' },
    seleProps: {
      label: 'fullname',
      valueName: 'userId',
    }
  },
  {
    type: 'SELECT',
    label: '团队',
    value: '',
    upKey: 'orgId',
    options: [],
    placeholder: '请选择团队',
    selectFunc: organizationsApi,
    seleProps: { label: 'name', valueName: 'id', },
    props: { placeholder: '请选择团队', clearable: true }
  },
])

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_tabs, { type: "border-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, { label: "月度工资" }, {
          default: _withCtx(() => [
            _createVNode(monthlySalary)
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "年度工资",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(annualSalary, {
              basicParams: {},
              basicSearchConfig: annualSalaryConfig.value,
              basicApi: _unref(annual_salaryApi)
            }, {
              columnHead: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "姓名",
                  prop: "realName",
                  width: "130",
                  "show-overflow-tooltip": ""
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.userName + ' (' + row.alias + ')'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "日期 Date",
                  width: "95",
                  prop: "month",
                  fixed: ""
                })
              ]),
              _: 1
            }, 8, ["basicSearchConfig", "basicApi"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "邮件",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(sendEmail)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})